export default {
    data() {
        return {
            currentContractorType: {},
            searchContent: "",
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 12,
            dialogManageShow: false,
            manageForm: {},
            multipleSelection: [],
            contractorTypeList: []
        }
    },
    mounted: function() {
        this.requestContractorType();
        this.query();
    },
    methods: {

        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function(id) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "reset": //重置
                    this.currentContractorType = {};
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //新增
                    this.manageForm = {};
                    this.requestContractorType();
                    this.dialogManageShow = true;
                    break;
                case "edit": //修改
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.dialogManageShow = true;
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的承包商, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => {});
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.id == null)
                                this.add();
                            else
                                this.edit();
                        } else {
                            return false;
                        }
                    });
                    break;
                default:
                    break;
            }
        },

        /**
         * 左侧承包商类型点击
         * @param {*} node 
         * @param {*} nodeObj 
         * @param {*} comp 
         */
        treeClick: function(node, nodeObj, comp) {
            this.currentContractorType = node;
            this.pageIndex = 1;
            this.query();
        },

        /**
         * 格式化日期
         * @param {*} date 
         */
        formatDate: function(date) {
            if (date == null)
                return "-";
            if (date.length <= 10)
                return date.substring(0, date.length);
            return date.substring(0, 10);
        },

        /**
         * table选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function(val) {
            this.multipleSelection = val;
        },

        /**
         * 查询承包商类型
         */
        requestContractorType: function() {
            this.$post({
                url: "/contractorType/queryByPage",
                params: {
                    keyWord: "",
                    pageIndex: 1,
                    pageSize: 10000
                }
            }).then(res => {
                this.contractorTypeList = res.data;
            });
        },

        /**
         * 新增
         */
        add: function() {
            this.$post({
                url: "/contractor/add",
                params: {
                    name: this.manageForm.name,
                    contractorTypeId: this.manageForm.contractorTypeId,
                    qualifications: this.manageForm.qualifications
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("添加成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function() {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/contractor/delete",
                params: {
                    ids: ids
                }
            }).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 修改
         */
        edit: function() {
            this.$post({
                url: "/contractor/edit",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    contractorTypeId:this.manageForm.contractorTypeId,
                    orgId:this.manageForm.orgId,
                    qualifications: this.manageForm.qualifications
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("修改成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function() {
            this.$post({
                url: 'contractor/queryByPage',
                params: {
                    contractorTypeId: this.currentContractorType.id,
                    keyWord: this.searchContent,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        },

        /**
         * 翻页
         * @param {*} val 
         */
        handlePageChange: function(val) {
            this.pageIndex = val;
            this.query();
        }
    }
}